import type { SignUpFormData } from "./store/types";
import { parsePhoneNumberFromString } from "libphonenumber-js";

type ValidationErrors = Partial<Record<keyof SignUpFormData, string>>;

export const validateSignUpForm = (
  formData: SignUpFormData
): ValidationErrors => {
  const errors: ValidationErrors = {};

  // Validate phone
  if (!formData.phone) {
    errors.phone = "Phone number is required";
  } else {
    const phoneNumber = parsePhoneNumberFromString(formData.phone);
    if (!phoneNumber || !phoneNumber.isValid()) {
      errors.phone = "Please enter a valid phone number";
    }
  }

  return errors;
};
